import { render, staticRenderFns } from "./ToggleListContent.vue?vue&type=template&id=513e1536&scoped=true&"
import script from "./ToggleListContent.vue?vue&type=script&lang=ts&"
export * from "./ToggleListContent.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleListContent.vue?vue&type=style&index=0&id=513e1536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e1536",
  null
  
)

export default component.exports